var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "streamline-icon-shopping-cart-empty-1@140x140",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.63 26.292"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19",
    d: "M25.592 7.408a1.1 1.1 0 00-1.055-1.384H5.744a.273.273 0 01-.271-.219l-.627-2.98A3.576 3.576 0 001.369 0a1.37 1.37 0 100 2.739.824.824 0 01.8.657L5.644 19.9a3.562 3.562 0 001.355 2.115.273.273 0 01.014.426 2.191 2.191 0 103.4.682.272.272 0 01.012-.266.276.276 0 01.233-.129h6.54a.274.274 0 01.245.4 2.189 2.189 0 103.916-.013.264.264 0 01.236-.383 1.37 1.37 0 100-2.739H9.125a.825.825 0 01-.8-.652l-.2-.937a.274.274 0 01.268-.329h11.78a3.286 3.286 0 003.17-2.422z",
    fill: "#575757"
  })));
}

export default __webpack_public_path__ + "3ad4aac6a993f907e8d1ba6284ea27a0.svg";
export { SvgCart as ReactComponent };